<template>
    <HelpButton @click="isShowDialog = true" />

    <!-- ヒント用のダイアログ -->
    <HelpDialog :isShow="isShowDialog" @close="isShowDialog = false" title="ファイルやフォルダパスの取得方法について">
        <template v-slot:contents>
            <div>
                <h2>■方法1.</h2>
                <p>エクスプローラーでフォルダを開き、赤枠部分からパスをコピーしてください。</p>
                <img src="@/assets/helps/HowToGet-SyncDirPath-1.png" alt="フォルダのパス取得方法1" width="900px">
            </div>
            <div>
                <h2>■方法2.</h2>
                <p>方法1でパスが上手く取得できない場合はこちら。※ダウンロードフォルダなどではパスが省略されてしまう</p>
                <p>
                    エクスプローラーでフォルダを右クリックし、赤枠部分と青枠部分をスラッシュ「/」でつなげたパスを入力してください。<br>
                    下記の場合、「C:\Users\user.user\Downloads\cli_sync」を入力してください。<br>
                    ※コマンドを生成する際、バックスラッシュはスラッシュに自動で置換されます。<br>
                </p>
                <img src="@/assets/helps/HowToGet-SyncDirPath-2.png" alt="フォルダのパス取得方法2" width="900px">
            </div>
            <div>
                <h2>■方法3.</h2>
                <p>ファイルパスに関しては、上記の方法で取得したフォルダパスに、「/」でファイル名をつなげてください。</p>
            </div>
        </template>
    </HelpDialog>
</template>
<script>
import { ref } from 'vue'

export default {
    name: 'PathHelp',
    setup() {

        // ###########
        // ダイアログ #
        // ###########
        const isShowDialog = ref(false)
        const updateDialog = (state) => {
            isShowDialog.value = state
        }

        return { updateDialog, isShowDialog }
    }
}
</script>
